import { Inject, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Component, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WebRequestService } from 'src/app/services/web-request.service';
import { LoaderComponent } from '../builders/loader/loader.component';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss']
})
export class ImageSliderComponent implements OnInit {
  slideConfig: any = {}
  @Input() profileDataImages: any = []
  @Output() closeEventTrigger = new EventEmitter();
  @ViewChild('slideShowModal') public slideShowModal;
  @ViewChild('slickModal')  slickModalView: any;
  imageData: any=[];
  LoaderComponent: any = '';

  constructor(public dialogRef: MatDialogRef<ImageSliderComponent>,
    @Inject(MAT_DIALOG_DATA) private modalData: any,public service: WebRequestService,) {
    this.slideConfig = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      centerMode: false,
      dots: false,
      autoplaySpeed: 20000000,
      autoplay: true,
      infinite: true,
      lazyLoad: "ondemand",
      method: {},
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }
      ],
    };

  }

  ngOnInit(): void {
    if (this.modalData.custID) {
      this.LoaderComponent = LoaderComponent
      this.service.getOtherUserPhotoSearch(Number(this.modalData.custID)).then((res) => {
        this.LoaderComponent = ''
        if (res['statusCode'] === 200) {
          this.imageData  = res['result']
        } else {
  
        }
      })
    }
   
  }
  ngAfterViewInit(): void{
    this.slideConfig[
      'prevArrow'
    ]= `.profile-left`
    this.slideConfig[
      'nextArrow'
    ] = `.profile-right`
    if(this.slickModalView!=undefined){
      // this.slideShowModal.show();
      setTimeout(()=>{
        this.imageData = this.imageData;
      },300)
    }
  }
  closeImgPreview() {
    this.closeEventTrigger.emit(true);
    
  }
  closeModal() {
    this.dialogRef.close();
    this.slickModalView.ngOnDestroy();
  }

}
